import { CollaboratorsApiRemoteService } from '../../Services/api/collaborators/collaborators-service'
import {  ICollaboratorEntity, ICreateCollaboratorPayload } from '../../Services/api/collaborators/collaborators.interface'
import { IFormUsecase } from '../../Shared/Protocol/protocol-form-usecase'
import { Result } from '../../Shared/Protocol/protocol-result'


export class CreateCollaboratorsUseCase
implements IFormUsecase<ICreateCollaboratorPayload, ICollaboratorEntity> {
  constructor (private readonly CollaboratorsApi: CollaboratorsApiRemoteService) {}
    

  public async handle (
    data: ICreateCollaboratorPayload
  ): Promise<Result<ICollaboratorEntity>> {
    // eslint-disable-next-line no-useless-catch
    try {

      const response = await this.CollaboratorsApi.create(data)

      if (response.isFailure) {
        return response
      }
    
      return Result.ok()
    } catch (error: any) {
      return Result.fail(error)
    }
  }

 
}
